import type { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';
import { RouteError, RoutePending } from '@/components/shell/route-states';
import { routeTree } from '../routeTree.gen';

export interface RouterContext {
  queryClient: QueryClient;
}

export function createAppRouter(queryClient: QueryClient) {
  return createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: 'intent',
    // Loaders read through the Query cache, which owns staleness.
    defaultPreloadStaleTime: 0,
    scrollRestoration: true,
    defaultPendingComponent: RoutePending,
    defaultPendingMs: 250,
    defaultErrorComponent: RouteError,
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}

/** Accepts only same-origin relative paths as post-login redirects (blocks open redirects). */
export function safeRedirectPath(value: string | undefined): string {
  // Browsers drop tabs/newlines inside URLs ("/\t/evil" becomes "//evil"), and this app's paths
  // never contain control characters or backslashes, so any of them means "go home".
  // biome-ignore lint/suspicious/noControlCharactersInRegex: matching control characters is the point
  if (!value || /[\u0000-\u001f\u007f\\]/.test(value)) return '/';
  if (!value.startsWith('/') || value.startsWith('//')) return '/';
  return value;
}
